import { render, staticRenderFns } from "./RootField.vue?vue&type=template&id=4d7cacfe&scoped=true&lang=pug&"
import script from "./RootField.vue?vue&type=script&lang=ts&"
export * from "./RootField.vue?vue&type=script&lang=ts&"
import style0 from "./RootField.vue?vue&type=style&index=0&id=4d7cacfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7cacfe",
  null
  
)

export default component.exports